import { registerFeatureWithDescription } from "lib/features"

export const FEATURE_FLAG_LEGISLATION_LIBRARY = registerFeatureWithDescription({
    numericalId: 405,
    id: "legislation-library",
    name: "Legislation Library",
    internalUseOnly: true,
    readyForProduction: false,
    descriptionLines: ["Grants access to the Legislation Library feature."],
})
